export default "__VITE_ASSET__kwZFo$Bs__"